import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ILogger } from '@nimbus-library/features/logger/services/logger/i-logger';
import { LicenseItemDisableReasonTranslationMapper } from '@nimbus-library/features/shared/components/material/input-license/input-license.model';
import { BaseUserInputLicenseCheckboxItemComponent } from '../base/base-user-input-license-checkbox-item-component.directive';

@Component({
  standalone: false,
  selector: 'nimbus-user-input-license-checkbox-item',
  templateUrl: './user-input-license-checkbox-item.component.html',
  styleUrls: ['../input-wrapper-license.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInputLicenseCheckboxItemComponent extends BaseUserInputLicenseCheckboxItemComponent {
  @Input() public isSmall: boolean = false;
  @Input() public infoLabel: string;
  @Input() public image: string;
  @Input() public beta: boolean;

  protected readonly translationMapper = LicenseItemDisableReasonTranslationMapper;

  public constructor(
    protected readonly changeDetectionRef: ChangeDetectorRef,
    protected readonly loggerService: ILogger,
    protected readonly translateService: TranslateService,
  ) {
    super(changeDetectionRef, loggerService, translateService);
  }
}
